import { getData, postData } from "../../../services/global.service";
import "./FreeTrailForm.scss"
import { HOMEPAGE_API_CONSTANTS, IMAGE_ICONS } from "../constant/hompage.constant";
import { APIEnv, APIStatus } from "../../../interface/baseInterfaces";
import { LocalStorageDataModel } from "../../../constants/local-storage-data-model";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import { memo, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DOMPurify from "dompurify";
import { Env, getDataFromLocalStorage, removeDataFromLocalStorage, setDataOnLocalStorage } from "../../../utils/globalUtilities";
import useDebounce from "../../../hooks/useDebounce/useDebounce";
import { useNavigate } from "react-router-dom";
import { AppRouteURL } from "../../../routes/app-route-urls";
import Loader from "../../../components/loader/Loader";
import { ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD } from "../constant/endMileAPI.event.list";
import { triggerFreeTrailNewEndmileEvent } from "../../../utils/endmile";

const timer = 60;
const sanitizeInput = (value: any) => DOMPurify.sanitize(value);
const staticData = {
    BrowserName: "Chrome",
    SocialLoginName: "",
    PlatformTypeName: "OTHERS",
    DeviceTypeName: "DESKTOP",
    utmsource: "",
    utm_medium: "",
    utm_campaign: "",
};
interface TrailFormProps {
    userData: any;
    isEmailOtpSent: boolean;
    isMobileOtpSent: boolean;
    timeLeftForEmail: string | number;
    resendDisabledForEmail: boolean;
    timeLeftForMobile: string | number;
    resendDisabledForMobile: boolean;
    isSendClick: boolean;
    fetchUserData: () => void;
    verifyEmailOtp: () => void;
    verifyMobileOtp: () => void;
    sendEmailOTP: () => void;
    sendMobileOTP: () => void;
    setIsSendClick: (type: boolean) => void;
    activeIcon:any;
    setActiveIcon:any;
    showSuccessIcon:any;
    handleFieldFocus:any;
    otpInValidaionConsentError:string;
    setOtpInValidaionConsentError:any
}

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Required")
        .test(
            "min-valid-chars",
            "Name must contain at least 2 valid characters",
            (value: string | null | undefined) => !!value && value.trim().length >= 2
        )
        .nullable(),
    email: Yup.string()
        .required("Required")
        .email("Invalid email address")
        .nullable(),
    phone: Yup.string()
        .when('phoneVerified', {
            is: 0,
            then: (schema) => schema.required("Required")
                .min(10, "Must be 10 characters")
                .max(10, "Must be 10 characters")
                .nullable(),
            otherwise: (schema) => schema.nullable(),
        }),
    pincode: Yup.string()
        .matches(/^[0-9]+$/, "PIN code must be numeric")
        .length(6, "PIN code must be exactly 6 digits")
        .required("Required")
        .nullable(),
     enum: Yup.boolean().required('To proceed, please check the box above')

});

export const FreeTrailForm = () => {
    let formikRef: any = useRef();
    const navigate = useNavigate();
    const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
    const [loading, setLoading] = useState<boolean>(false);
    const [pincodeVerified, setPincodeVerified] = useState<boolean>(false);
    const [initialFormValues, setInitialFormValues] = useState<any>({
        name: "",
        email: "",
        phone: "",
        pincode: "",
        organisation: "",
        emailOtp: "",
        mobileOtp: "",
        emailVerified: 0,
        phoneVerified: 0,
        enum: true
    });
    const [userData, setUserData] = useState<any>(null);
    const [isEmailOtpSent, setIsEmailOtpSent] = useState(false);
    const [timeLeftForEmail, setTimeLeftForEmail] = useState(0);
    const [resendDisabledForEmail, setResendDisabledForEmail] = useState(false);
    const [isMobileOtpSent, setIsMobileOtpSent] = useState(false);
    const [timeLeftForMobile, setTimeLeftForMobile] = useState(0);
    const [resendDisabledForMobile, setResendDisabledForMobile] = useState(false);
    const [userToken, setUserToken] = useState("");
    const activeCampaign: any = getDataFromLocalStorage(
        LocalStorageDataModel.UTM_CAMPAIGN_NAME
    );
    const utmData = getDataFromLocalStorage(activeCampaign);
    const [isSendClick, setIsSendClick] = useState(false)
    const [showSuccessIcon, setShowSuccessIcon] = useState(false);
    const [activeIcon, setActiveIcon] = useState<any>("DEFAULT");
    const [stateNamebyPincode, setStateNamebyPincode] = useState<any>("");
    const [otpInValidaionConsentError, setOtpInValidaionConsentError] = useState<string>('');
    const handleFieldFocus = (iconKey: any) => {
        setActiveIcon(iconKey);
    };


    useEffect(() => {
        if (token && !userData) getUserDataHandler({});
    }, []);

    useEffect(() => {
        if (formikRef?.current?.values?.pincode.length >= 6) {
            getData(HOMEPAGE_API_CONSTANTS.GET_STATE_BY_PINCODE + `?pinCode=${formikRef?.current?.values?.pincode}`,
                {},
                null,
                APIEnv.NODE_DASHBOARD).then((resp: any) => {
                  if(resp?.ResponseType == "SUCCESS" && resp?.data.stateName){
                    setStateNamebyPincode(resp?.data)
                    setPincodeVerified(true)
                  }else{
                    toast.error(resp?.StatusMsg)
                  }
                })
                .catch((error: any) => {
                setPincodeVerified(false);
                    toast.error(error.response?.data?.StatusMsg);
                });
        }
    }, [formikRef?.current?.values?.pincode])

    useEffect(() => {
        if (timeLeftForEmail > 0) {
            const timer = setInterval(() => {
                setTimeLeftForEmail((prevTime) => prevTime - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else {
            setTimeLeftForEmail(timer);
            if (isEmailOtpSent) {
                setIsEmailOtpSent(false);
                setResendDisabledForEmail(true);
            }
        }
    }, [timeLeftForEmail]);

    useEffect(() => {
        if (timeLeftForMobile > 0) {
            const timer = setInterval(() => {
                setTimeLeftForMobile((prevTime) => prevTime - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else {
            setTimeLeftForMobile(timer);
            if (isMobileOtpSent) {
                setIsMobileOtpSent(false);
                setResendDisabledForMobile(true);
            }
        }
    }, [timeLeftForMobile]);

    const onSubmit = async (values: any) => {
        if (!userData?.email_verified) {
            toast.error("Please verify email");
            return;
        }
        if (!userData?.is_verified) {
            toast.error("Please verify mobile number");
            return;
        }
        if (!isSendClick) {
            toast.error("Please verify email and mobile number first");
            return;
        }

        if(pincodeVerified == false){
            toast.error("Please enter valid pincode");
            return
        }
        const name = sanitizeInput(values?.name);
        const organisation = sanitizeInput(values?.organisation);
        if (!name.trim()) {
            toast.error("Please enter valid name");
            return;
        }
        if(!values.enum){
            setOtpInValidaionConsentError('To proceed, please check the box above')
        sentConsent(values.email, values.phone);
            return;
        }else{
                        setOtpInValidaionConsentError('');
        }
        setLoading(true)
        const data = {
            ...values,
            name: name,
            organisation: organisation,
            phone: `+91${values?.phone}`,
            ...JSON.parse(utmData || "{}"),
            optinconsent: 1
        };
        delete data?.emailOtp;
        delete data?.mobileOtp;
        delete data?.emailVerified;
        delete data?.phoneVerified;
        return await postData(
            token
                ? HOMEPAGE_API_CONSTANTS.REGISTER_FOR_FREE_TRAIL_LOGGED_IN_USER
                : HOMEPAGE_API_CONSTANTS.REGISTER_FOR_FREE_TRAIL_LOGGED_OUT_USER,
            data,
            APIEnv.NODE_DASHBOARD,
            "post",
        )
            .then(async (res: any) => {
                setShowSuccessIcon(true);
                if (res?.ResponseType === APIStatus.SUCCESS) {
                    const endmileUtmData = [];
                    if (utmData) {
                        const utmDataObj = JSON.parse(utmData);
                        endmileUtmData.push({
                            fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.UTM_CAMPAIGN,
                            value: utmDataObj?.utm_campaign,
                        });
                        endmileUtmData.push({
                            fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.UTM_MEDIUM,
                            value: utmDataObj?.utm_medium,
                        });
                        endmileUtmData.push({
                            fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.UTM_SOURCE,
                            value: utmDataObj?.utm_source,
                        });
                    }
                    else{
                        endmileUtmData.push({
                            fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.UTM_SOURCE,
                            value: "Website",
                        });
                    }
                    if (token) {
                        setLoading(false)
                       await triggerFreeTrailNewEndmileEvent(null, endmileUtmData, "");
                        removeDataFromLocalStorage(LocalStorageDataModel.UTM_CAMPAIGN_NAME);
                        removeDataFromLocalStorage(LocalStorageDataModel.UTM_CAMPAIGN_URL);
                        removeDataFromLocalStorage(activeCampaign);
                        setTimeout(()=>{
                            navigate(`/${AppRouteURL.HOME}`);
                        },300)
                        toast.success(
                            "Your 7 days free trial of Taxmann.com | Premium has been activated!"
                        );                    
                    } else {
                        const endmileData = [
                            {
                                fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.FIRST_NAME_LAST_NAME,
                                value: name,
                            },
                            {
                                fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.COUNRTY_CODE,
                                value: "+91",
                            },
                            {
                                fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PHONE_NUMBER,
                                value: values?.phone,
                            },
                            {
                                fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.STATE,
                                value: stateNamebyPincode?.stateName,
                            },
                            {
                                fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.CITY,
                                value: stateNamebyPincode?.cityName,
                            },
                        ];
                        await triggerFreeTrailNewEndmileEvent(
                            endmileData,
                            endmileUtmData,
                            userData?.email
                        );

                        removeDataFromLocalStorage(LocalStorageDataModel.UTM_CAMPAIGN_NAME);
                        removeDataFromLocalStorage(LocalStorageDataModel.UTM_CAMPAIGN_URL);
                        removeDataFromLocalStorage(activeCampaign);


                        if (userData?.newUser) {
                            setDataOnLocalStorage("email", userData?.email);
                            setDataOnLocalStorage("PREVIOUS_URL", "/premium/home");
                            setTimeout(()=>{window.open(
                                Env().RESET_PASSWORD_SCREEN +
                                `?emailId=${userToken?.split("Bearer")[1]}&type=ppcpremium`,
                                "_self"
                            )},2500)
                            toast.success(
                                "Your 7 days free trial of Taxmann.com | Premium has been activated!"
                            );
                        } else {
                            setTimeout(()=>{
                              navigate(`/${AppRouteURL.HOME}`);
                             },300)
                            toast.success(
                                "Your 7 days free trial of Taxmann.com | Premium has been activated!"
                            );
                        }
                    }
                    setLoading(false)
                }
                if (res?.ResponseType === APIStatus.PLANALREADYACTIVATED) {
                    toast.error(res?.StatusMsg)
                    setLoading(false)
                }
                if (res?.ResponseType === APIStatus.TRIAL_ALREADY_TAKEN) {
                    toast.error(res?.StatusMsg)
                    setLoading(false)
                }

            })
            .catch((err) => {
                setLoading(false)
                const error = err?.response?.data;
                if (error?.ResponseType === APIStatus.ERROR) {
                    setLoading(false)
                    toast.error(error?.StatusMsg);
                }
            });
    };

    const sendEmailOTP = async () => {
        if (formikRef.current) {
            const email = formikRef.current?.values?.email;
            if (email && (/[a-z0-9]+@[a-z0-9-]+\.[a-z]{2,3}/).test(email)) {
                const response = await postData(
                    HOMEPAGE_API_CONSTANTS.SEND_EMAIL_OTP,
                    { email },
                    APIEnv.NODE_DASHBOARD,
                    "post"
                );
                if (response && response.ResponseType == "EMAIL_OTP_SENT") {
                    setLoading(false)
                    toast.success("Email OTP send successfully");
                    setIsEmailOtpSent(true);
                    setTimeLeftForEmail(timer);
                    setResendDisabledForEmail(false);
                }
            } else {
                formikRef.current.setFieldTouched("email", true);
            }
        }
    };

    const sendMobileOTP = async () => {
        if (userData?.is_verified) {
            setIsSendClick(true)
            return
        }
        if (formikRef.current) {
            if (!userData?.email_verified) {
                toast.error("Please verify Email first.")
                return
            }
            const phone = formikRef.current?.values?.phone;
            const email = formikRef.current?.values?.email;
            if (phone?.length == 10 && email) {
                const data = {
                    email: email,
                    mobile: phone,
                    countrycode: "+91",
                    type: "edit",
                };
                setLoading(true)
                await postData(
                    HOMEPAGE_API_CONSTANTS.SEND_MOBILE_OTP,
                    data,
                    APIEnv.NODE_DASHBOARD,
                    "post"
                )
                    .then((response) => {
                        setLoading(false)
                        if (response && response.ResponseType == "OTP_SEND") {
                            toast.success("Mobile OTP send successfully");
                            setIsMobileOtpSent(true);
                            setTimeLeftForMobile(timer);
                            setResendDisabledForMobile(false);
                        } else if (
                            response &&
                            response.ResponseType == "PHONE_ALREADY_EXIST"
                        ) {
                            toast.error(response?.StatusMsg);
                        }
                    })
                    .catch((err) => {
                        setLoading(false)
                        const error = err?.response?.data;
                        toast.error(error?.StatusMsg);
                    });
            } else {
                if (!email) {
                    toast.error("Email is required");
                    return;
                }
                if (phone.length != 10) {
                    toast.error("Invalid mobile number");
                    return;
                }
                // formikRef.current.setFieldTouched("phone", true);
                // formikRef.current.setFieldError("phone", "Required");
            }
        }
    };

    const getUserDataHandler = async (data: any) => {
        setLoading(true)
        try{
        const userDataResponse:any = await postData(
            HOMEPAGE_API_CONSTANTS.GET_FREE_TRAIL_USER_DETAIL,
            data,
            APIEnv.NODE_PREMIUM,
            "post"
        );
        if (userDataResponse?.ResponseType === "SUCCESS") {
            const userDetails = userDataResponse?.data?.userDetails || {};
            const data = userDataResponse?.data || {}; 

            const isEmailVerified = data?.email_verified || userDetails?.email_verified;
            const isPhoneVerified = (data?.phone || userDetails?.phone) 
                ? (data?.is_verified || userDetails?.is_verified ? 1 : 0)
                : 0;
                
            if (isEmailVerified && isPhoneVerified) {
                setIsSendClick(true);
            }
        
            setUserData({
                ...userDetails,
                ...data,
                is_verified: (data?.phone || userDetails?.phone)
                    ? (data?.is_verified || userDetails?.is_verified ? 1 : 0)
                    : 0,
            });
        
            const {
                email,
                company_name,
                first_name,
                last_name,
                pincode,
                phone,
                email_verified,
                is_verified,
                token = "",
            } = { ...data, ...userDetails }; 
        
            const tempUserData = {
                name: first_name + " " + last_name,
                email: email,
                phone: phone || formikRef?.current?.values?.phone,
                pincode: pincode || formikRef?.current?.values?.pincode,
                organisation: company_name,
                emailVerified: email_verified,
                phoneVerified: phone && is_verified ? 1 : 0,
                enum: true
            };
            
            if (!email_verified) {
                sendEmailOTP(); 
                setLoading(false)
            } else {
                setLoading(false)            
            }
            
            setUserToken(token);
            setInitialFormValues(tempUserData);
            }
        }
        catch (err: any) {
            setLoading(false)
            toast.error(err?.response?.data?.StatusMsg);
        }
    };
    

    const fetchUserData = () => {
        const { name, email } = formikRef?.current?.values ?? {};
        const data = {
            firstName: name?.split(" ")[0],
            lastName: name?.split(" ")[1] || "",
            email,
        };
        if (!userData) {
            getUserDataHandler(data);
        }
    };

    const verifyEmailOtp = async () => {
        if (userData?.email_verified==1) {
            return;
        }
        const data = {
            ...staticData,
            verify: "E",
            email: formikRef.current?.values?.email,
            emailOTP: parseInt(formikRef.current?.values?.emailOtp),
        };
        setLoading(true)
        await postData(
            HOMEPAGE_API_CONSTANTS.VERIFY_OTP,
            data,
            APIEnv.NODE_DASHBOARD,
            "post"
        )
            .then((response) => {
                if (response?.ResponseType == "VERIFIED") {
                    toast.success("Email Verified");
                    setIsEmailOtpSent(false);
                    setTimeLeftForEmail(0);
                    setResendDisabledForEmail(false);
                    setUserData({ ...userData, email_verified: 1 });
                    setLoading(false)
                }
            })
            .catch((err) => {
                const error = err?.response?.data;
                toast.error(error?.StatusMsg);
                setLoading(false)
            });
    };

    const verifyMobileOtp = async () => {
        if (userData?.is_verified) {
            return;
        }
        const data = {
            ...staticData,
            verify: "M",
            mobile: formikRef.current?.values?.phone,
            countrycode: "+91",
            OTP: parseInt(formikRef.current?.values?.mobileOtp),
            email: formikRef.current?.values?.email,
            registerFor: "PREMIUM_TRIAL",
        };
        setLoading(true)
        await postData(
            HOMEPAGE_API_CONSTANTS.VERIFY_OTP,
            data,
            APIEnv.NODE_DASHBOARD,
            "post"
        )
            .then((response) => {
                if (response?.ResponseType == "VERIFIED") {
                    toast.success("Mobile Verified");
                    setIsMobileOtpSent(false);
                    setTimeLeftForMobile(0);
                    setResendDisabledForMobile(false);
                    setUserData({ ...userData, is_verified: 1 });
                    setLoading(false)
                }
            })
            .catch((err) => {
                const error = err?.response?.data;
                toast.error(error?.StatusMsg);
                setLoading(false)
            });
    };

enum consent_type {
REGISTRATION,
  PRACTICE_PPC,
  RESEARCH_PPC,
  LEARNING ,
  PREMIUM ,
  TAXMANN_AI ,
  ACADEMY
}

const sentConsent = (email:string, phone:string) => {
    let data ={ "email": email,
    "phone": phone,
     "enum": consent_type.PREMIUM};
     postData(
                    HOMEPAGE_API_CONSTANTS.SEND_OTP_CONSENT,
                    data,
                    APIEnv.NODE_DASHBOARD,
                    "post"
                )
                    .then((response) => {

                    })
                    .catch((err) => {
                    });
}

    return (
        <section className="form-sections">




            
            {loading && <Loader />}
            <div>
            <div className="trail">
                <div className="trail-flex">
                    <div className="col-12 lg:col-5">
                    
                        <div className="start">
                        {/* <Parallax translateY={[15, 20]} opacity={[0, 1]} speed={0} > */}
                            <h2 className="free_trial_head">Start Your Free Trial Now!</h2>
                            <div className="free_trial_icons"> 

                            <span className="free_icons_1">
    {showSuccessIcon ? (
        <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/tick_mark.png" alt="Success Icon" />
    ) : activeIcon === "DEFAULT" ? (
        <img
            src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_1.png"
            alt="Default Icon"
        />
    ) : activeIcon && IMAGE_ICONS[activeIcon as keyof typeof IMAGE_ICONS] ? (
        <img src={IMAGE_ICONS[activeIcon as keyof typeof IMAGE_ICONS]} alt={activeIcon} />
    ) : null}
</span>


                            </div>
                            
                            {/* <h2> Enjoy unlimited access to webinars and choose 2 recorded sessions from workshops or masterclasses of your interest. </h2> */}
                            {/* </Parallax> */}
                        </div>
                        
                    </div>
                    <div className="col-12 lg:col-7">
                        <div className="form-login" id="targetDiv">
                            <Formik
                                enableReinitialize
                                innerRef={formikRef}
                                initialValues={initialFormValues}
                                validationSchema={ValidationSchema}
                                validateOnChange={true}
                                onSubmit={onSubmit}
                            >
                                {() => (
                                    <Form
                                        autoComplete="off"
                                    >
                                        <TrailForm
                                            userData={userData}
                                            isEmailOtpSent={isEmailOtpSent}
                                            isMobileOtpSent={isMobileOtpSent}
                                            timeLeftForEmail={timeLeftForEmail}
                                            resendDisabledForEmail={resendDisabledForEmail}
                                            timeLeftForMobile={timeLeftForMobile}
                                            resendDisabledForMobile={resendDisabledForMobile}
                                            isSendClick={isSendClick}
                                            sendEmailOTP={sendEmailOTP}
                                            sendMobileOTP={sendMobileOTP}
                                            fetchUserData={fetchUserData}
                                            verifyEmailOtp={verifyEmailOtp}
                                            verifyMobileOtp={verifyMobileOtp}
                                            setIsSendClick={setIsSendClick}
                                            activeIcon={activeIcon}
                                            setActiveIcon={setActiveIcon}
                                            showSuccessIcon={showSuccessIcon}
                                            handleFieldFocus={handleFieldFocus}
                                            otpInValidaionConsentError={otpInValidaionConsentError}
                                            setOtpInValidaionConsentError={setOtpInValidaionConsentError}
                                        />
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    );
};

const VerifiedIcon = () => (
    <div className="flex mt-2">
        <svg
            fill="none"
            height="18"
            viewBox="0 0 24 24"
            width="18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_8084_24023)">
                <path
                    d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11.003 16L18.073 8.929L16.659 7.515L11.003 13.172L8.174 10.343L6.76 11.757L11.003 16Z"
                    fill="#2BD157"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_8084_24023">
                    <rect fill="white" height="24" width="24"></rect>
                </clipPath>
            </defs>
        </svg>
        <span className="ml-2" style={{ color: "#2BD157", marginLeft: 2, fontSize: 14 }}>Verified</span>
    </div>
);

const TrailForm = memo((props: TrailFormProps) => {
    const {
        userData,
        isEmailOtpSent,
        isMobileOtpSent,
        timeLeftForEmail,
        resendDisabledForEmail,
        timeLeftForMobile,
        resendDisabledForMobile,
        isSendClick,
        sendEmailOTP,
        sendMobileOTP,
        fetchUserData,
        verifyEmailOtp,
        verifyMobileOtp,
        setIsSendClick,
        handleFieldFocus,
        otpInValidaionConsentError,
        setOtpInValidaionConsentError
    } = props;
    const { values } = useFormikContext<any>();

    useDebounce(
        () => {
            // if (values?.name && values?.email && emailRegex.test(values?.email)) {
            //     fetchUserData();
            // }
            if (
                values?.emailOtp &&
                values?.emailOtp?.length &&
                values?.emailOtp?.length == 6
            ) {
                verifyEmailOtp();
            }
            if (
                values?.mobileOtp &&
                values?.mobileOtp?.length &&
                values?.mobileOtp?.length == 6
            ) {
                verifyMobileOtp();
            }
        },
        [values],
        1000
    );

    const formatTime = (seconds: any) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const handleInput = (e: any) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
    };

    const getUserData = () => {
        const trimmedName = (values?.name || "").trim();
        if (trimmedName.length < 2) {
            toast.error("Please enter a valid Name (at least 2 characters)");
            return;
        }
        if (trimmedName && values?.email) {
            setIsSendClick(true);
            if (userData && userData.email === values.email) {
                sendEmailOTP();
            } else {
                fetchUserData();
            }
        } else {
            toast.error("Please enter Name and Email ID");
        }
    }

    return (
        <div className="ppt-7-days-free-trial " id="free-trial">
            <div className="f-g-row">
                <label className="ppt-form-label"> Name <span className="red">*</span></label>
                <Field
                    type="text"
                    name="name"
                    placeholder="Enter Your Name"
                    className="form-control-input"
                    onFocus={() => handleFieldFocus('NAME')}
                />
                <ErrorMessage name="name" className="error" component="span" />
            </div>
            <div className="digit-group">
                <label className="ppt-form-label"> Email <span className="red">*</span></label>
                <div className="ppt-input-btn-box">
                    <Field
                        disabled={parseInt(userData?.email_verified) || isEmailOtpSent}
                        type="email"
                        name="email"
                        placeholder="Enter Your Email"
                        className={
                            parseInt(userData?.email_verified)
                                ? "form-control-input disabled"
                                : "form-control-input"
                        }
                        onFocus={() => handleFieldFocus('EMAIL')}
                    />
                    {(!parseInt(userData?.email_verified) && !isEmailOtpSent) ||
                        resendDisabledForEmail || !isSendClick ? (
                        <span className="fix-colls-1">
                            <button
                                type="button"
                                className="ppt-button-primary"
                                onClick={() => getUserData()}
                            >
                                {resendDisabledForEmail && !isEmailOtpSent
                                    ? "Resend OTP"
                                    : "Get OTP"}
                            </button>
                        </span>
                    ) : null}
                </div>
                {parseInt(userData?.email_verified) && isSendClick ? <VerifiedIcon /> : null}
                <ErrorMessage name="email" className="error" component="span" />
                {isEmailOtpSent && (
                    <p className="resend_otp tw-mt-2">
                        Resend OTP in {formatTime(timeLeftForEmail)} seconds
                    </p>
                )}
            </div>
            {(!parseInt(userData?.email_verified) && isEmailOtpSent) ||
                resendDisabledForEmail ? (
                <div className="digit-group">
                    <label className="ppt-form-label"> Email OTP <span className="red">*</span>  </label>
                    <div className="ppt-input-btn-box">
                        <Field
                            maxLength={6}
                            type="text"
                            name="emailOtp"
                            placeholder="Enter Email OTP"
                            className="form-control-input"
                        />
                    </div>
                    <ErrorMessage name="emailOtp" className="error" component="span" />
                </div>
            ) : null}
            <div className="digit-group">
                <label className="ppt-form-label">Organisation (Optional)</label>
                <div className="ppt-input-btn-box">
                    <Field
                        type="text"
                        name="organisation"
                        placeholder="Enter Your Organisation"
                        className="form-control-input"
                        onFocus={() => handleFieldFocus('ORGANISATION')}
                    />
                </div>
            </div>
            <div className="digit-group">
                <label className="ppt-form-label"> Phone <span className="red">*</span>  </label>
                <div className="ppt-input-btn-box">
                    <div className="user-control-1">
                        <div className="ppt-user-drop-1">
                            +91
                            <svg
                                fill="none"
                                height="20"
                                viewBox="0 0 21 20"
                                width="21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.5 7.5L10.5 12.5L15.5 7.5"
                                    stroke="#667085"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.66667"
                                ></path>
                            </svg>
                        </div>
                    </div>
                    <div className="user-control-1 control-flex">
                        <Field
                            disabled={parseInt(userData?.is_verified) || isMobileOtpSent}
                            type="text"
                            name="phone"
                            placeholder="Enter Your Phone"
                            className={
                                parseInt(userData?.is_verified)
                                    ? "user-feilds disabled"
                                    : "user-feilds"
                            }
                            maxLength={10}
                            onInput={handleInput}
                            onFocus={() => handleFieldFocus('PHONE')}
                        />
                        {(!parseInt(userData?.is_verified) && !isMobileOtpSent) ||
                            resendDisabledForMobile || !isSendClick ? (
                            <span className="fix-colls-1">
                                <button
                                    type="button"
                                    onClick={() => {  sendMobileOTP() }}
                                    className="ppt-button-primary "
                                >
                                    {resendDisabledForMobile && !isMobileOtpSent
                                        ? "Resend OTP"
                                        : "Get OTP"}
                                </button>
                            </span>
                        ) : null}
                    </div>
                </div>
                {parseInt(userData?.is_verified) && isSendClick ? <VerifiedIcon /> : null}
                <ErrorMessage name="phone" className="error" component="span" />
                {isMobileOtpSent && (
                    <p className="resend_otp tw-mt-2">
                        Resend OTP in {formatTime(timeLeftForMobile)} seconds
                    </p>
                )}
                <div className="ppc-otp-box"></div>
            </div>
            {(!parseInt(userData?.is_verified) && isMobileOtpSent) ||
                resendDisabledForMobile ? (
                <div className="digit-group">
                    <label className="ppt-form-label"> Mobile OTP <span className="red">*</span>  </label>
                    <div className="ppt-input-btn-box">
                        <Field
                            maxLength={6}
                            type="text"
                            name="mobileOtp"
                            placeholder="Enter Mobile OTP"
                            className="form-control-input"
                        />
                    </div>
                    <ErrorMessage name="mobileOtp" className="error" component="span" />
                </div>
            ) : null}
            <div className="f-g-row">
                <label className="ppt-form-label"> Pin Code <span className="red">*</span>  </label>
                <Field
                    type="text"
                    name="pincode"
                    placeholder="Enter Your Pin Code"
                    className="form-control-input"
                    maxLength={6}
                    onInput={handleInput}
                    onFocus={() => handleFieldFocus('PINCODE')}
                />
                <ErrorMessage name="pincode" className="error" component="span" />
            </div>
                        <div className="digit-group">
                <div className="ppt-input-btn-box">
<label className="ppt-form-label ui-custom-checkbox ui-checkbox-row">
                    <Field className=""
                        type="checkbox"
                        name="enum"
                        placeholder="Accept promotional messages"
                          onClick={(e:any) => {
              if (!e.target.checked) {
                // If checkbox is unchecked, clear related field
            setOtpInValidaionConsentError('To proceed, please check the box above')
              }else{
            setOtpInValidaionConsentError('')
              }
            }}
                        onFocus={() => handleFieldFocus('ENUM')}
                    />
<span className="checkmark"></span>
             I consent to receive communications from Taxmann and its related entities through email, SMS, telephone calls, or other electronic means regarding product updates, services, offers, and related information.</label>
                </div>
                                <ErrorMessage name="enum" className="error" component="span" />
                                {
                                otpInValidaionConsentError?.length ? 
                                <span className="error"> {otpInValidaionConsentError} </span>
                                 : ''}
            </div>
            <div className="f-g-row p-mt-4">
                <div className="f-g-colls p-d-flex p-jc-end">
                    <button className="ppc-trial-primary-btn" type="submit">
                        Get 7 Days Free Trial{" "}
                    </button>
                </div>
            </div>
        </div>
    );
});
